import React, { memo } from "react";
import {
  ExclamationCircleOutlined,
  DownCircleOutlined,
} from "@ant-design/icons";
import { docType } from "../../constants/DocTypeConstants";
interface IpropsDocumentInfo {
  upload: boolean;
  text: string;
  onClick: React.MouseEventHandler<HTMLElement>;
}
export const DocumentInfo = memo((props: IpropsDocumentInfo) => {
  const { upload, text, onClick } = props;
  const isTextOk = typeof text === "string" ? text : "";

  if (upload) {
    return (
      <div
        style={{ cursor: "pointer", wordBreak: "break-all" }}
        onClick={onClick}
      >
        <DownCircleOutlined style={{ color: "#21A038", marginRight: "5px" }} />
        <>{isTextOk}</>
      </div>
    );
  } else if (!upload && text) {
    return (
      <>
        <ExclamationCircleOutlined
          style={{ color: "#c33e3e", marginRight: "5px" }}
        />
        <span style={{ color: "#c33e3e" }}>{text}</span>
      </>
    );
  }
  return (
    <>
      <ExclamationCircleOutlined
        style={{ color: "#c33e3e", marginRight: "5px" }}
      />
      <>Форматы: {docType.join(", ")}. Обьем не более 20 мб.</>
    </>
  );
});

DocumentInfo.displayName = "DocumentInfo";
